var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import RCDrawer from 'rc-drawer';
import 'rc-drawer/assets/index.css';
import { useRef } from 'react';
import styled, { css } from 'styled-components';
import useThemeBreakpoints from '../../hooks/useThemeBreakpoints';
import { Elevation } from '../../theme/elevation';
import { ThemeFamilies } from '../../theme/families';
import getThemeBreakpoints from '../../utils/getThemeBreakpoints';
import Icon, { IconName } from '../Icon';
import { HeaderFiveTypography } from '../Typography/headerFive';
export var DrawerVariants;
(function (DrawerVariants) {
    DrawerVariants["THIN"] = "thin";
    DrawerVariants["WIDE"] = "wide";
})(DrawerVariants || (DrawerVariants = {}));
var Drawer = function (_a) {
    var staticSize = _a.staticSize, name = _a.name, className = _a.className, themeFamily = _a.themeFamily, header = _a.header, hideHeader = _a.hideHeader, children = _a.children, onClose = _a.onClose, variant = _a.variant, drawerProps = __rest(_a, ["staticSize", "name", "className", "themeFamily", "header", "hideHeader", "children", "onClose", "variant"]);
    var childrenRef = useRef(null);
    var themeBreakpoints = useThemeBreakpoints({
        component: variant === DrawerVariants.THIN ? 'drawer' : 'drawerWide',
        staticSize: staticSize,
    });
    var handleClose = function () {
        if (onClose)
            onClose(null);
        if (childrenRef.current) {
            childrenRef.current.scrollTo(0, 0);
        }
    };
    var handleChange = function (isOpen) {
        if (!isOpen)
            handleClose();
    };
    return (_jsx(StyledRCDrawer, __assign({ level: null, handler: false, showMask: false, onClose: handleClose, onChange: handleChange, width: themeBreakpoints.width, "data-testid": name, className: className, placement: "right" }, drawerProps, { children: _jsxs(ContentWrapper, __assign({ "data-testid": name + "-content-wrapper", className: "drawer-custom-wrapper", variant: variant }, { children: [_jsx(Header, __assign({ staticSize: staticSize, hideHeader: hideHeader, themeFamily: themeFamily, "data-testid": name + "-header", className: "drawer-header" }, { children: !hideHeader && (_jsxs(_Fragment, { children: [_jsx(HeaderContentWrapper, __assign({ className: "header-content-wrapper" }, { children: header }), void 0),
                            _jsx(CloseIcon, { onClick: handleClose, name: IconName.DELETE, themeFamily: themeFamily }, void 0)] }, void 0)) }), void 0),
                _jsx(ChildrenWrapper, __assign({ staticSize: staticSize, "data-testid": name + "-children-wrapper", ref: childrenRef, className: "drawer-children-wrapper" }, { children: children }), void 0)] }), void 0) }), void 0));
};
Drawer.defaultProps = {
    themeFamily: ThemeFamilies.PRIMARY,
    variant: DrawerVariants.THIN,
};
export default Drawer;
var StyledRCDrawer = styled(RCDrawer)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  & .drawer-content-wrapper {\n    box-shadow: ", " !important;\n  }\n"], ["\n  & .drawer-content-wrapper {\n    box-shadow: ", " !important;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.elevation[Elevation.DEPTH10];
});
var ContentWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n  height: 100%;\n"], ["\n  ", "\n\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n  height: 100%;\n"])), function (_a) {
    var variant = _a.variant;
    return getThemeBreakpoints(variant === DrawerVariants.THIN ? 'drawer' : 'drawerWide');
});
var Header = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n\n  height: 60px;\n  align-items: center;\n  display: flex;\n  box-sizing: border-box;\n\n  ", "\n"], ["\n  ", "\n\n  height: 60px;\n  align-items: center;\n  display: flex;\n  box-sizing: border-box;\n\n  ",
    "\n"])), getThemeBreakpoints('drawerHeader'), function (_a) {
    var hideHeader = _a.hideHeader, theme = _a.theme, themeFamily = _a.themeFamily;
    var _b = theme.families.drawer[themeFamily], main = _b.main, text = _b.text;
    return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      color: ", ";\n      ", ";\n    "], ["\n      color: ", ";\n      ", ";\n    "])), text, !hideHeader && "border-bottom: 1px solid " + main);
});
var HeaderContentWrapper = styled(HeaderFiveTypography)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  margin: 0;\n"], ["\n  margin: 0;\n"])));
var CloseIcon = styled(Icon)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  margin-left: auto;\n  font-size: 24px;\n\n  ", "\n"], ["\n  margin-left: auto;\n  font-size: 24px;\n\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme, themeFamily = _a.themeFamily;
    return css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    color: ", ";\n  "], ["\n    color: ", ";\n  "])), theme.families.drawer[themeFamily].light);
});
var ChildrenWrapper = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  flex: 1;\n  overflow: auto;\n  box-sizing: border-box;\n"], ["\n  flex: 1;\n  overflow: auto;\n  box-sizing: border-box;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
